import React, {Component} from "react";
import * as Yup from "yup";
import _ from "lodash";
import {connect} from "react-redux";

import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import Form from "../../../../../utils/forms/components/Form";
import {GamesActionCreators} from "../../../actions/actionCreators";
import {gamesStoreSelectors} from "../../../store/store";
import {ActionCreator} from "../../../../../actions/actions";

import {CreationModes} from "../../../reducers/creationMode.reducer";

import "./CreateBundle.component.scss";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

const bundleFormFields = _.memoize(
    ({games, items}): FormGridField[] => [
        {
            name: "bundle_id",
            fieldType: "input",
            fieldOptions: {
                id: "bundle_id",
                placeholder: "BundleID",
                label: "BundleID"
            },
            validation: Yup.number().integer('Please enter a valid number.').required('Please enter a number.'),
            columnClass: "col-6"
        },
        {
            name: "name",
            fieldType: "input",
            fieldOptions: {
                id: "name",
                placeholder: "Name",
                label: "Name"
            },
            validation: Yup.string()
                .required("Field is required.")
                .max(50, "Max. 50 characters."),
            columnClass: "col-6"
        },
        {
            name: "games",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "games",
                items: games,
                completeList: games,
                enableSearch: true,
                orderByLabel: true
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-12"
        },
        {
            name: "alias",
            fieldType: "inputAlias",
            fieldOptions: {
                id: "alias",
                placeholder: "Alias",
                label: "Alias",
                items: items
            },
            columnClass: "col-12"
        }
    ]
);

let new_bundle_id = null;

export interface CreateBundleProps {
    creatingBundle: {
        values: any;
        isValid: boolean;
    };
    creationMode: any;
    updateCreatingBundle: ActionCreator;
    clearCreateBundle: ActionCreator;
    editBundle: any;
    createBundle: any;
    getGames: ActionCreator;
    gamesLoading: boolean;
    games: any;
    subsidiaries: any;
}

class CreateBundle extends Component<CreateBundleProps> {
    form: React.RefObject<Form>;

    constructor(props) {
        super(props);
        this.form = React.createRef();

        this.props.getGames({page: 1, top: 10000, type: null});
        new_bundle_id = null;
    }

    onCreate = () => {
        let bundle = {...this.props.creatingBundle.values};
        bundle.bundle_id = new_bundle_id;
        this.props.createBundle(bundle);
    };

    onEdit = () => {
        let bundle = {...this.props.creatingBundle.values};
        bundle.bundle_id = new_bundle_id;
        this.props.editBundle(bundle);
    };

    formChange = e => {
        let values = {...e.values};
        let isFormValid = e.isValid;
        new_bundle_id = values.bundle_id
        this.props.updateCreatingBundle(values, isFormValid);
    };

    render() {
        if (this.props.gamesLoading) {
            return (
                <div id="create-bundle">
                    <div className="create-content">
                        <div className="loading-container">
                            <Components.LoadingRipple
                                width={"100px"}
                                height={"100px"}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        let formFields = bundleFormFields({
                games: this.props.games.results.map(game => {
                    return {
                        value: game.id,
                        label: game.name
                    };
                }),
                items: this.props.subsidiaries
            }
        );
        let formKey = "form-initial";
        let bundle_values = this.props.creatingBundle
            ? this.props.creatingBundle.values
            : {
                bundle_id:"",
                name: "",
                subsidiary: null,
                games: undefined,
                alias: []
            }
        bundle_values.bundle_id = bundle_values.id

        return (
            <div id="create-bundle">
                <div className="create-content">
                    <div className="new-game-card">
                        <Form
                            key={formKey}
                            ref={this.form}
                            fields={formFields}
                            initialValues={bundle_values}
                            onChange={this.formChange}
                        />
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="red-btn create-btn"
                                    disabled={
                                        !this.props.creatingBundle ||
                                        !this.props.creatingBundle.isValid
                                    }
                                    onClick={this.props.creationMode == CreationModes.ADD_BUNDLE ?
                                        this.onCreate :
                                        this.onEdit}
                                >
                                    {this.props.creationMode == CreationModes.ADD_BUNDLE ? "Create" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: gamesStoreSelectors.creationMode(state),
    creatingBundle: gamesStoreSelectors.creatingBundle(state),
    games: gamesStoreSelectors.games(state),
    gamesLoading: gamesStoreSelectors.gamesLoading(state)
});

const mapDispatchToProps = {
    updateCreatingBundle: GamesActionCreators.updateCreatingBundle,
    clearCreateBundle: GamesActionCreators.clearCreateBundle,
    getGames: GamesActionCreators.getGames
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateBundle);
